export enum PaymentType {
    Pallet = 1,
    Item = 2,
}

export const enumLabel = (value?: PaymentType) => {
    switch (value) {
        case PaymentType.Pallet:
            return 'Палета';
        case PaymentType.Item:
            return 'Упаковка';
        default:
            return '';
    }
};
